import { z } from 'zod';

export interface RescheduleDirectFormData {
  timeSlot: Date | undefined;
  day: Date | undefined;
  calendarId?: string;
  slotId?: string;
  showOnlyCurrentTherapist?: boolean;
}

export const rescheduleDirectFormSchema = z.object({
  timeSlot: z.date({ required_error: 'Please, pick up a timeslot to continue.', invalid_type_error: 'Please, pick up a timeslot to continue.' }),
  day: z.date({ required_error: 'Please, pick up a day.' }),
  calendarId: z.string().optional(),
  slotId: z.string().optional(),
  showOnlyCurrentTherapist: z.boolean().optional(),
});
